import Point from 'editor/geometry/Point';

export interface DrawRectInteractionStorage {
  originX: number;
  originY: number;
  hit: Point;
}

class DrawRectInteraction {
  originX: number;

  originY: number;

  hit: Point;

  constructor(storage: DrawRectInteractionStorage) {
    this.originX = storage.originX;
    this.originY = storage.originY;
    this.hit = storage.hit;
  }
}

export default DrawRectInteraction;
